import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

/**
 * The subset of a "how it works" step's data needed to track a click on its link: the step's own
 * `key` and its link's `href`, rather than the full `Step` type, so any future step with a link is
 * tracked automatically instead of needing a step-2-specific handler.
 */
export type StepLink = Readonly<{
	key: string;
	href: string;
}>;

type Result = ModelHookResult<
	undefined,
	{
		trackLinkClick: (step: StepLink) => void;
	}
>;

export function useHowItWorks(): Result {
	const track = useTracking();

	const trackLinkClick = useCallback(
		(step: StepLink) => {
			void track('ambassadors_outbound_link_click', {
				link_location: `process_${step.key}`,
				url: step.href,
			});
		},
		[track],
	);

	return {
		actions: {
			trackLinkClick,
		},
	};
}
